import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { Button, Chip } from '../ui';
import { buildQrCardsHtml, printQrCards, PrintFormat, QrCard } from '../utils/printQr';

/** /qr-print-preview — QR картыг хэвлэхээс өмнө харах. ?building=&format=a6|a4x4|a4x6&bw=1 */
export default function QrPrintPreviewPage() {
  const [sp, setSp] = useSearchParams();
  const building = sp.get('building') || '';
  const format = (sp.get('format') as PrintFormat) || 'a6';
  const bw = sp.get('bw') === '1';
  const [data, setData] = useState<{ soh_name: string; soh_phone?: string; items: QrCard[] } | null>(null);
  useEffect(() => { api.get<any>(`/admin/units/qr-batch${building ? `?building=${encodeURIComponent(building)}` : ''}`).then(setData).catch(() => setData({ soh_name: '', items: [] })); }, [building]);
  const set = (k: string, v: string) => { const n = new URLSearchParams(sp); v ? n.set(k, v) : n.delete(k); setSp(n, { replace: true }); };
  const html = useMemo(() => data ? buildQrCardsHtml(data.items.slice(0, format === 'a6' ? 2 : 6), data.soh_name, format, bw, false, data.soh_phone || '') : '', [data, format, bw]);
  const cards = data?.items.length || 0;
  return (
    <div className="theme-light">
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 14 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0, flex: 1 }}>QR карт — урьдчилан харах</h2>
        {(['a6', 'a4x4', 'a4x6'] as PrintFormat[]).map(f => <Chip key={f} tone="filter" on={format === f} onClick={() => set('format', f)}>{f === 'a6' ? 'A6 · 1 карт' : f === 'a4x4' ? 'A4 · 4 карт' : 'A4 · 6 карт'}</Chip>)}
        <Chip tone="filter" on={bw} onClick={() => set('bw', bw ? '' : '1')}>Хар-цагаан</Chip>
        <Button icon="printer" disabled={!data || !cards} onClick={() => data && printQrCards(data.items, data.soh_name, format, bw, data.soh_phone || '')}>Хэвлэх ({cards})</Button>
      </div>
      <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 10 }}>{building ? `${building} байр` : 'Бүх байр'} · {cards} карт · эхний {format === 'a6' ? 2 : 6}-ыг харуулж байна. Хэвлэхэд бүх карт орно.</div>
      <iframe title="QR карт" srcDoc={html} style={{ width: '100%', height: 'calc(100vh - 170px)', border: '1px solid var(--line)', borderRadius: 12, background: '#fff' }} />
    </div>
  );
}
